var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"footer",staticClass:"owc-footer",attrs:{"role":"contentinfo"}},[(_vm.loaded)?_c('OwcFooterContent',{attrs:{"componentData":_vm.componentData,"isEdit":_vm.isEditMode}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }